import { jsxs, jsx } from "react/jsx-runtime";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
const EmptyState = ({ classes, className, subTitle, title, icon, children, size = "md" }) => {
  const { themeClasses } = useThemePresetClasses("EmptyState", classes, className, {
    modifier: size
  });
  return /* @__PURE__ */ jsxs("div", { className: cn(themeClasses == null ? void 0 : themeClasses.root), children: [
    icon,
    title && /* @__PURE__ */ jsx(
      "h3",
      {
        className: cn(themeClasses == null ? void 0 : themeClasses.title, {
          "mt-1": !!icon
        }),
        children: title
      }
    ),
    title && /* @__PURE__ */ jsx("p", { className: cn(themeClasses == null ? void 0 : themeClasses.subTitle), children: subTitle }),
    children
  ] });
};
const EmptyState$1 = EmptyState;
export {
  EmptyState$1 as default
};
